import DesktopHeader from 'src/components/util/DesktopHeader';
import EmailLink from 'src/components/util/EmailLink';
import MobileHeader from 'src/components/util/MobileHeader';

/**
Confirmation component
@param {string} text - The text to be displayed in the component
@param {array} contacts - An array of objects containing contact information
@returns {JSX} - A JSX component that displays a confirmation message and contact information
*/
export default function Confirmation({ text = '', contacts = [] }) {
  return (
    <div className="flex h-screen flex-col">
      <MobileHeader />
      <DesktopHeader />
      <div className="m-auto flex max-w-xs items-center sm:max-w-lg">
        <div className="m-auto flex max-w-xs items-center sm:max-w-lg">
          <div className="flex flex-col gap-4 rounded p-4 shadow-lg">
            <h1 className="text-center text-xl font-bold">{text}</h1>
            <p className="text-center">
              If you have additional questions about your submitted form, contacts{' '}
              {contacts[0].name} at <EmailLink email={contacts[0].email} />, {contacts[0].phone}
              {contacts[1] && (
                <>
                  , or {contacts[1].name} at <EmailLink email={contacts[1].email} />
                  {' ' + contacts[1].phone}.
                </>
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
